import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-cta',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <section class="cta">
      <div class="container">
        <div class="cta-content">
          <h2>Prêt à rejoindre le mouvement Zero-Waste ?</h2>
          <p>
            Inscrivez-vous dès aujourd'hui et commencez à valoriser vos invendus
            tout en contribuant à un avenir plus durable.
          </p>
          <div class="cta-buttons">
            <a
              [routerLink]="['/create-account']"
              class="btn-home btn-primary-home btn-large"
              >Créer un compte</a
            >
            <a href="#" class="btn-home btn-secondary-home btn-large"
              >En savoir plus</a
            >
          </div>
        </div>
        <div class="cta-image">
          <img
            src="https://images.unsplash.com/photo-1542838132-92c53300491e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80"
            alt="Panier d'invendus alimentaires"
          />
        </div>
      </div>
    </section>
  `,
  styles: [
    `
      .cta {
        background-color: var(--secondary-color);
        padding: 100px 0;
        position: relative;
        overflow: hidden;
      }

      .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 40px;
      }

      .cta-content {
        flex: 1;
      }

      .cta-content h2 {
        font-size: 2.5rem;
        margin-bottom: 20px;
        color: var(--text-color);
      }

      .cta-content p {
        font-size: 1.2rem;
        margin-bottom: 30px;
        color: var(--dark-gray);
        max-width: 600px;
      }

      .cta-buttons {
        display: flex;
        gap: 20px;
      }

      .cta-image {
        flex: 1;
        display: flex;
        justify-content: flex-end;
      }

      .cta-image img {
        max-width: 100%;
        border-radius: 20px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        transform: perspective(1000px) rotateY(5deg);
        transition: transform 0.5s ease;
      }

      .cta-image img:hover {
        transform: perspective(1000px) rotateY(0);
      }

      @media (max-width: 992px) {
        .cta {
          padding: 80px 0;
        }

        .cta-content h2 {
          font-size: 2.2rem;
        }
      }

      @media (max-width: 768px) {
        .container {
          flex-direction: column;
        }

        .cta-content {
          text-align: center;
        }

        .cta-content p {
          margin: 0 auto 30px;
        }

        .cta-buttons {
          justify-content: center;
          flex-wrap: wrap;
        }

        .cta-image {
          justify-content: center;
          margin-top: 40px;
          order: -1;
        }
      }
    `,
  ],
})
export class CtaComponent {}
